export const hspFlags = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  PPP_Neymar: '--table-casual-neymar'
};
